import { combineReducers } from 'redux'

import bankAccountList from './bankAccountList'
import bankAccountSetup from './bankAccountSetup'
import internalBankTransfer from './internalBankTransfer'
import bankTransfer from './bankTransfer'
import bookingAssignments from './bookingAssignments'
import bookingAssistant from './bookingAssistant'
import bankContactSettings from './bankContactSettings'

export default combineReducers({
  bankAccountList,
  bankAccountSetup,
  internalBankTransfer,
  bankTransfer,
  bookingAssignments,
  bookingAssistant,
  bankContactSettings,
})
